<router-outlet></router-outlet>
<app-modal></app-modal>
<!-- <app-modal-event-notice></app-modal-event-notice> -->
